import cn from 'classnames';
import type { HTMLAttributes, MouseEventHandler, PropsWithChildren} from 'react';
import { memo, useCallback, useContext } from 'react';
import gtag from '../analytics/gtag';
import * as style from './TabButton.module.css';
import { TrackingContext } from './TrackingContext';

interface Props {
    selected?: boolean;
    onSelect(): void;
    disabled?: boolean;
    large?: boolean;
}

export default memo(function TabButton({ selected = false, onSelect, disabled = false, large, children }: PropsWithChildren<Props>) {
    const { tab_name } = useContext(TrackingContext);
    const onClick: MouseEventHandler<HTMLButtonElement> = useCallback(
        (e) => {
            onSelect();
            gtag('event', 'tabs', {
                tab_name,
                link_text: e.currentTarget.textContent,
            });
        },
        [onSelect, tab_name],
    );
    return (
        <button
            role="tab"
            className={cn(style.tabBtn, { [style.selected]: selected, [style.disabled]: disabled, [style.large]: large })}
            aria-selected={selected}
            onClick={!selected ? onClick : undefined}
        >
            {children}
        </button>
    );
});

export function TabGroup({ children, ...props }: PropsWithChildren<HTMLAttributes<HTMLDivElement>>) {
    return (
        <div className={style.tabGroup} role="tablist" {...props}>
            {children}
        </div>
    );
}
